import { render, staticRenderFns } from "./SearchModel.vue?vue&type=template&id=56f0b146&scoped=true&"
import script from "./SearchModel.vue?vue&type=script&lang=js&"
export * from "./SearchModel.vue?vue&type=script&lang=js&"
import style0 from "./SearchModel.vue?vue&type=style&index=0&id=56f0b146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f0b146",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
